<h4>{{ 'profiles.view.history.label' | translate | titlecase }}</h4>

<div class="history-container">
  <div class="card-field-label"> {{ dateChanged | date: 'longDate' }}</div>
  {{ 'profiles.view.history.change-date' | translate | titlecase }}
  <div class="row-divider"></div>

  <div class="card-field-label"> {{ dateCreated | date: 'longDate' }}</div>
  {{ 'profiles.view.history.create-date' | translate | titlecase }}
 

</div>


